import Title from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import { useIntl } from 'react-intl';
import Content from 'components/common/Content-v2';
import MembersTable from 'components/tables/members';
import CircleButton from 'components/common/ButtonIcon';
const Members = () => {
	const { formatMessage } = useIntl();
	const allyId = localStorage.getItem('allyId');

	const handleBack = () => {
		localStorage.removeItem('allyId');
		window.location.reload();
	};
	return (
		<>
			<Title>
				<h1>{formatMessage({ id: 'dashboard.members' })}</h1>
				<LinkButton to="/admin/members/add">{formatMessage({ id: 'members.createMember' })}</LinkButton>
				{allyId && (
					<CircleButton
						type="button"
						icon="arrow_back"
						onClick={() => handleBack()}>
						{formatMessage({ id: 'commons.back' })}
					</CircleButton>
				)}
			</Title>
			<Content>
				<MembersTable />
			</Content>
		</>
	);
};
export default Members;
